import { TriggerConfigSchema } from "@redotech/redo-shopper-agent-common/trigger-config";
import { ShopperAgentChannelsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/channel-config";
import { ShopperAgentCooldownConfigSchema } from "@redotech/redo-shopper-agent-settings-common/cooldown-config";
import { ShopperAgentDiscountConfigSchema } from "@redotech/redo-shopper-agent-settings-common/discount-config";
import { ShopperAgentEmailConfigSchema } from "@redotech/redo-shopper-agent-settings-common/email-config";
import { ShopperAgentEscalationConfigSchema } from "@redotech/redo-shopper-agent-settings-common/escalation-config";
import { ShopperAgentHumanQueueConfigSchema } from "@redotech/redo-shopper-agent-settings-common/human-queue-config";
import { ShopperAgentIMessageConfigSchema } from "@redotech/redo-shopper-agent-settings-common/imessage-config";
import { ShopperAgentPersonaConfigSchema } from "@redotech/redo-shopper-agent-settings-common/persona-config";
import { ShopperAgentRcsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/rcs-config";
import { ShopperAgentReplyConfigSchema } from "@redotech/redo-shopper-agent-settings-common/reply-config";
import { SkillConfigSchema } from "@redotech/redo-shopper-agent-settings-common/skill-config";
import { ShopperAgentSupervisorConfigSchema } from "@redotech/redo-shopper-agent-settings-common/supervisor-config";
import * as z from "zod";

/** Live (or draft-preferring) shopper-agent settings returned to merchant editors. */
export const PublishedShopperAgentSettingsSchema = z.object({
  enabled: z.boolean(),
  channels: ShopperAgentChannelsConfigSchema.optional(),
  replyConfig: ShopperAgentReplyConfigSchema.optional(),
  recoverConfig: ShopperAgentHumanQueueConfigSchema.optional(),
  escalationConfig: ShopperAgentEscalationConfigSchema.optional(),
  iMessageConfig: ShopperAgentIMessageConfigSchema.optional(),
  personaConfig: ShopperAgentPersonaConfigSchema.optional(),
  discountConfig: ShopperAgentDiscountConfigSchema.optional(),
  cooldownConfig: ShopperAgentCooldownConfigSchema.optional(),
  supervisorConfig: ShopperAgentSupervisorConfigSchema.optional(),
  skills: z.record(z.string(), SkillConfigSchema).optional(),
  rcsConfig: ShopperAgentRcsConfigSchema.optional(),
  emailConfig: ShopperAgentEmailConfigSchema.optional(),
  triggers: z.record(z.string(), TriggerConfigSchema).optional(),
});

export const getPublishedShopperAgentSettings = {
  name: "getPublishedShopperAgentSettings" as const,
  input: z.object({}),
  output: z.object({
    /** Null when nothing is published (agent off). */
    settings: PublishedShopperAgentSettingsSchema.nullable(),
  }),
};
